import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { LinksList as LinksLinksComponent } from "./LinksList";

const LinksListConnector = ({ data }) => (
	<LinksLinksComponent
		linkEntries={data.linkEntries}
		listStyle={data.listStyle}
		title={data.title}
		titleAs={data.titleAs}
		titleSize={data.titleSize}
	/>
);

LinksListConnector.propTypes = {
	data: PropTypes.shape({
		linkEntries: PropTypes.arrayOf(
			PropTypes.shape({
				url: PropTypes.string.isRequired,
				target: PropTypes.string,
				linkText: PropTypes.string,
				id: PropTypes.string,
			})
		),
		listStyle: PropTypes.string,
		title: PropTypes.string,
		titleAs: PropTypes.string,
		titleSize: PropTypes.string,
	}),
};
LinksListConnector.defaultProps = {
	data: null,
};

export default LinksListConnector;
export { LinksListConnector };
